/* eslint-disable max-len */
import 'react';

const HeaderPagePublicSvg = (): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h12v12H0z" />
            <g stroke="currentColor" strokeWidth="1.2">
                <path d="M3.6 4.8h4.8A1.2 1.2 0 019.6 6v3.2a1.2 1.2 0 01-1.2 1.2H3.6a1.2 1.2 0 01-1.2-1.2V6a1.2 1.2 0 011.2-1.2z" />
                <path
                    d="M4 4.8V3.52c0-1.06.95-1.92 2.12-1.92.817 0 1.526.418 1.88 1.032M6 8v-.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </g>
    </svg>
);
export default HeaderPagePublicSvg;
